// Blog hero image — four companion portraits in a tinted band.
import { Mascot, type MascotName } from "../components/Mascot";

type BlogCompanion = {
  name: MascotName;
  accent: string;
  tint: string;
};

const COMPANIONS: BlogCompanion[] = [
  { name: "Otto", accent: "#6366F1", tint: "#E0E7FF" },
  { name: "Summi", accent: "#EC4899", tint: "#FCE7F3" },
  { name: "Quill", accent: "#F59E0B", tint: "#FEF3C7" },
  { name: "Sage", accent: "#10B981", tint: "#D1FAE5" },
];

export function BlogHeroImage() {
  return (
    <section className="px-[clamp(24px,5vw,80px)] pb-14">
      <div className="mx-auto flex max-w-[960px] flex-wrap items-center justify-center gap-[clamp(16px,4vw,40px)] rounded-[28px] border border-indigo-200 bg-[linear-gradient(135deg,#EEF2FF_0%,#E0E7FF_100%)] px-[clamp(24px,4vw,48px)] py-[clamp(40px,6vw,64px)] shadow-[0_30px_60px_-30px_rgba(99,102,241,0.35)]">
        {COMPANIONS.map((c) => (
          <div
            key={c.name}
            className="flex flex-col items-center gap-3"
            style={
              {
                "--accent": c.accent,
                "--tint": c.tint,
              } as React.CSSProperties
            }
          >
            <div className="flex h-[clamp(96px,14vw,140px)] w-[clamp(96px,14vw,140px)] items-center justify-center overflow-hidden rounded-full border-[3px] border-white bg-[var(--tint)] shadow-[0_12px_28px_-10px_var(--accent)]">
              <Mascot name={c.name} size={140} />
            </div>
            <div className="font-companion text-[13px] font-semibold tracking-[0.04em] text-[var(--accent)]">
              {c.name}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
